import { Component } from '@angular/core';
import { ModalService } from './modal.service';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.css'
})
export class ModalComponent {

  modalType: string = '';
  modalTitle: string = '';
  modalMessage: string = '';
  showModal: boolean = false;

  constructor(private modalService: ModalService) {
    this.modalService.modal$.subscribe(modal => {
      this.modalType = modal.type;
      this.modalTitle = modal.title;
      this.modalMessage = modal.message;
      this.showModal = true;
    });
  }

  closeModal() {
    this.showModal = false;
  }

}
